import { Injectable } from '@angular/core';

import { Result } from './result';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  public results: Result[] = [];
  public searchPool: Result[] = [];

  constructor() { }

  addToPool(results: any[]) {
  }
}
